import type { ShellBridges, TabletApi } from './desktopDiscovery';

type Shell = Window & {
  Capacitor?: { isNativePlatform?(): boolean };
  rosaTablet?: TabletApi;
};

export async function installTabletApi(win: Window = window): Promise<void> {
  const shell = win as Shell;
  if (!shell.Capacitor?.isNativePlatform?.()) return;
  // Dynamic so the hosted bundle only loads Capacitor inside the native shell.
  const { registerPlugin } = await import('@capacitor/core');
  const discovery = registerPlugin<TabletApi['discovery'] & ShellBridges>('BridgeDiscovery');
  const google = registerPlugin<{ signIn(): Promise<{ idToken: string }> }>('GoogleSignIn');
  shell.rosaTablet = {
    version: 1,
    discovery,
    bridges: discovery,
    googleIdToken: async () => (await google.signIn()).idToken,
  };
}
